<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
        <div class="pxkeji-right-box pxkeji-list-search-main">
          <a-form class="ant-advanced-search-form pxkeji-list-search-box">
            <a-row :gutter="24">
              <a-col :style="{ textAlign: 'right' }">
                <a-button  type="primary"  :style="{ marginRight: '8px' }"  class="ui-search-action" @click="chooseCourse()">选择资料</a-button>
                <!-- <a-button  type="default"  class="ui-search-action">添加新课程</a-button> -->
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-config-provider>
          <template v-slot:renderEmpty>
            <a-empty>
              <span slot="description">还没有数据~</span>
            </a-empty>
          </template>
          <div class="config-provider">
            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="list.pagination"
              :dataSource="list.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status" color="green">是</a-tag>
                <a-tag v-else color="red">否</a-tag>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="编辑" size="small" @click="showTraincard(info)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="移除" size="small" @click="delInfo(info)" type="default" />
              </span>
            </a-table>
            <div class="totalbox" style="float: left;">
              <div>
                <span>共有：{{list.pagination.total}}条数据</span>
              </div>
            </div>
          </div>
        </a-config-provider>

      <a-modal
        v-model="hidden"
        :footer="false"
        destroyOnClose
        width="70%"
        :maskClosable="false"
        class="ui-modal"
      >
        <studyfileChoose @callbackMethod="closeCourseList" />
      </a-modal>

    </div>
    
  </a-spin>
</template>

<script>
import studyfileChoose from "./studyfileChoose.vue";

const columns = [
  {
    dataIndex: "times",
    key: "times",
    align: "center",
    title: "资料类型"
  },
  {
    dataIndex: "userInfo",
    key: "userInfo",
    align: "center",
    title: "编号",
  },
  {
    dataIndex: "attendance",
    key: "attendance",
    align: "center",
    title: "资料名称"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "类型"
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;

export default {
  name: "trainRecord",
  props: {
    infoData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      form: this.$form.createForm(this),
      dis: this.disabled,
      info: {
        name: "",
        code: "",
        address: "",
        reserve: false,
        site: false
      },
      data: [],
      isloading: false,
      loadingTip: "加载中...",
      AreaHolidayVo: [], //节假日
      AreaSpecialdayVo: [], //特殊日
      AreaWorkedayVo: [], //工作日
      hidden: false, //培训考核卡弹窗
      thisModelTitle:'',
      modelInfo:{},
    };
  },
  components: {
    studyfileChoose: studyfileChoose,
  },
  mounted() {
    this.$nextTick(function() {
      // this.showUser();
      that = this;

      // if (this.infoData.id) {
      //   //编辑
      //   this.infoData.status = this.$common.changeIntBoolean(
      //     this.infoData.status
      //   );
      //   this.info = this.infoData;
      //   this.info.region =
      //     this.info.region == null ? null : this.info.region.split("-");
      // }
      // this.getRegionList();
      this.GetList();
    });
  },
  methods: {
    //tab切换
    tabcallback(key) {
      if (key == 1) {
        this.waitShow = true;
        this.successShow = false;
      } else if (key == 2) {
        this.waitShow = false;
        this.successShow = true;
      } 
    },
    sumbit() {
      this.$emit("callbackMethod");
    },
    GetList() {
      this.list.datas = [
        {
          times: '网授',
          userInfo: "32010",
          attendance: "《安全生产法律法规》教材精讲",
          addTime: "安全生产",
          datakey5: '25',
          datakey6: '50',
          status: 1
        }
      ];
      return false;
    },
    //选择课程
    chooseCourse() {
      this.hidden = true;
    },
    closeCourseList() {
      this.hidden = false;
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      //console.log("上传", fileList);
      this.fileList = fileList;
    },
    handleScollMain() {
      return document.querySelector(".ant-modal-wrap");
    },

    searchChange(s) {
      this.isloading = true;
      this.$api.user
        .pageListAdmin(1, 20, s)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.adminlist = res.data.records;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    showUser() {
      this.isloading = true;
      this.$api.user
        .pageListAdmin(1, 20)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.adminlist = res.data.records;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
  }
};
</script>
<style>
</style>